import React, { useState, useEffect } from "react";

import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import Profilehead from "../../components/profile/profile_head";
import Profilerightcard from "../../components/profile/profile_right_card";
import Profiletabs from "../../components/profile/profile_tab";

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Spinner from "../../components/Spinner/spinner";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import api from "../../api";

const baseUrl = process.env.REACT_APP_BASE_URL;

const Profile = () => {
  const [loading, setLoading] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const [programs, setPrograms] = useState({
    profile: {},
    loyalty: {},
    sponsorship: {},
    loyalty_consumptions: {},
  });
  const [reading, setReading] = useState(0);
  const [profileData , setProfileData] = useState();
  const [activeTab, setActiveTab] = useState("editProfile");
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN}`);
    const token_horoscope = localStorage.getItem(
      `${process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE}`,
    );
    if (!token && !token_horoscope) {
      navigate("/signin", { replace: true });
    }
  }, []);
  useEffect(() => {
    const start = Date.now();

    const spinnerTimeout = setTimeout(() => {
      setShowSpinner(true);
    }, 500);
  }, []);



  const Profile = async () => {
    try {
        setLoading(true);
      const response = await api.get(`/accounts/profile`)
      setProfileData(response.data.data)
      setPrograms({
        sponsorship_code: response.data.data.sponsorship_code,
        referrals: response.data.data.referrals,
        loyalty_wallet: response.data.data.loyalty_wallet,
        loyalty: {
          programs: response.data.data.loyalty_programs,
        },
        sponsorship: {
          programs: response.data.data.sponsorship_programs,
        sponsorship_wallet: response.data.data.sponsorship_wallet
        },
      })
    } catch (error) {
      console.error(error)

    }
    finally {
      setLoading(false);
    }
  }


  useEffect(() => {
  //  fetchData();
  //  GetConsultation();
      Profile();
  }, []);

  return (
    <>
      {loading ? (
        showSpinner && <Spinner />
      ) : (
        <div
          className="row m-0"
          ref={(el) => {
            if (el) el.style.setProperty("display", "flex", "important");
          }}
        >
          <Profilehead data={programs} reading={reading} profileData={profileData} />

          <Profilerightcard profileData={profileData} />
          <Profiletabs dataprofile={programs} profileData={profileData}  setProfileData={setProfileData}
          activeTab={activeTab}
    setActiveTab={setActiveTab} />
        </div>
      )}
    </>
  );
};

export default Profile;
